import CivilStatusCertificate from './civil-status-certificate';
import {
  CertificateRadio,
  CertificateType,
  CertificateValueBorn,
  CertificateValueCitizenship,
  CertificateValueCivilUnion,
  CertificateValueDeath,
  CertificateValueMarriage,
  CertificationFormVM,
} from 'civil-status/view-models/document-birth-form';
import { memo, useMemo } from 'react';
import { Grid, useEventCallback } from '@mui/material';
import { useFormikContext } from 'formik';
import SearchMessages, { MessageType } from 'shell/components/shared/search-messages';
import { noop } from 'shell/utils/noop';
import { transformCertificateTitle } from 'civil-status/utils/transform-certificate-title';

const CertificationTypeComponent = (): React.ReactElement => {
  const formContext = useFormikContext<CertificationFormVM>();

  const handleCertificateType = useEventCallback((item: CertificateRadio | null) => {
    let selectedCertificate = '';

    const isCopia =
      item?.element?.key?.codiceDocumento?.toString() === CertificateValueBorn.copia ||
      item?.element?.key?.codiceDocumento?.toString() === CertificateValueMarriage.copia ||
      item?.element?.key?.codiceDocumento?.toString() === CertificateValueDeath.copia ||
      item?.element?.key?.codiceDocumento?.toString() === CertificateValueCivilUnion.copia ||
      item?.element?.key?.codiceDocumento?.toString() === CertificateValueCitizenship.copia;

    if (isCopia) {
      selectedCertificate = 'COPIACONFORME';
    }

    const isCertificato =
      item?.element?.key?.codiceDocumento?.toString() === CertificateValueBorn.certificato ||
      item?.element?.key?.codiceDocumento?.toString() === CertificateValueMarriage.certificato ||
      item?.element?.key?.codiceDocumento?.toString() === CertificateValueDeath.certificato ||
      item?.element?.key?.codiceDocumento?.toString() === CertificateValueCivilUnion.certificato ||
      item?.element?.key?.codiceDocumento?.toString() === CertificateValueCitizenship.certificato;

    if (isCertificato) {
      selectedCertificate = 'CERTIFICATO';
    }

    const isEstratto =
      item?.element?.key?.codiceDocumento?.toString() === CertificateValueBorn.estratto ||
      item?.element?.key?.codiceDocumento?.toString() === CertificateValueMarriage.estratto ||
      item?.element?.key?.codiceDocumento?.toString() === CertificateValueDeath.estratto ||
      item?.element?.key?.codiceDocumento?.toString() === CertificateValueCivilUnion.estratto ||
      item?.element?.key?.codiceDocumento?.toString() === CertificateValueCitizenship.estratto;

    if (isEstratto) {
      selectedCertificate = 'ESTRATTO';
    }

    formContext.setValues({
      ...formContext.values,
      user: '',
      pin: '',
      otp: '',
      certificate: item,
      selectedCertificate,
    } as CertificationFormVM);
  });

  const atto = useMemo(() => {
    return transformCertificateTitle({
      type: formContext.values.chosenDocument?.element?.codiceAtto?.toString() as CertificateType,
    });
  }, [formContext.values.chosenDocument?.element?.codiceAtto]);

  return (
    <Grid container spacing={2}>
      {formContext.errors.certificate && formContext.touched.certificate ? (
        <Grid item xs={12} md={12}>
          <SearchMessages
            type={MessageType.Error}
            title={'E presente un errore di validazione'}
            messages={[{ id: 1, value: formContext.errors.certificate }]}
            visibility={Boolean(formContext.errors.certificate && formContext.touched.certificate)}
            onChangeVisibility={noop}
          />
        </Grid>
      ) : undefined}
      <Grid item xs={12}>
        <CivilStatusCertificate
          selectedValue={formContext.values.certificate?.value}
          id="choose-type-certificate"
          type={
            formContext.values.chosenDocument?.element?.codiceAtto?.toString() as CertificateType
          }
          onChange={handleCertificateType}
          label={atto.type}
          isAnsc={formContext.values.chosenDocument?.isAnsc}
        />
      </Grid>
    </Grid>
  );
};

CertificationTypeComponent.displayName = 'Form generality component';

const CertificationTypeForm = memo(CertificationTypeComponent);

export default CertificationTypeForm;
